import {ApiV0} from '../api.v0';
import {RestApiService} from '../../rest-api.service';
import {ApiV0LicenseAssignment} from './contracting/api.v0.license-assignment';
import {ApiV0DeviceInfo} from './contracting/api.v0.device-info';
import {ApiV0DeviceData} from './contracting/api.v0.device-data';
import {ApiV0LicenseData} from './contracting/api.v0.license-data';

export class ApiV0Contracting {

  segment: string;

  constructor(v0: ApiV0, api: RestApiService) {
    this.segment = v0.segment + '/contracting';
    this.licenseAssignment = new ApiV0LicenseAssignment(this, api);
    this.deviceInfo = new ApiV0DeviceInfo(this, api);
    this.deviceData = new ApiV0DeviceData(this, api);
    this.licenseData = new ApiV0LicenseData(this, api);
  }

  public readonly licenseAssignment: ApiV0LicenseAssignment;
  public readonly deviceInfo: ApiV0DeviceInfo;
  public readonly deviceData: ApiV0DeviceData;
  public readonly licenseData: ApiV0LicenseData;
}
